import { CDItemTypesBySection } from '../../../ui-toolkit/enums/CDItemTypesBySection';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const byCDItemsForEscrowTable = (item: ICDV3ViewItem) => {
  const buyerAtClosing = item.buyer_at_closing || 0;
  const sellerAtClosing = item.seller_at_closing || 0;
  return (
    !item.netted_out && (buyerAtClosing > 0 || sellerAtClosing > 0) && CDItemTypesBySection.aj.indexOf(item.type) >= 0
  );
};
